<template>
  <el-dialog
    class="modify-solidity-contract-dialog common-dialog"
    title="修改合约文件"
    :visible.sync="showDialog"
    :before-close="cacel"
    top="25vh"
    @open="handleOpen"
  >
    <el-alert
      class="alert-info"
      title="提示"
      type="info"
      description="可修改Solidity合约文件的文件类型和Solidity版本"
      show-icon
      :closable="false"
    ></el-alert>
    <el-form ref="editSolidityContract" :model="model" :rules="rules" :label-width="`${adaptationVars.formLabelWidth}px`">
      <el-form-item label="合约名称" prop="name">
        <el-input
          v-model="model.name"
          placeholder="请输入合约名称"
          clearable
          :disabled="true"
        ></el-input>
      </el-form-item>
      <el-form-item label="文件类型" prop="type">
        <el-select v-model="model.type" placeholder="请选择文件类型" :disabled="true">
          <el-option
            v-for="(item, index) in typeOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Solidity版本" prop="version">
        <el-select v-model="model.version" placeholder="请选择Solidity版本">
          <el-option
            v-for="(item, index) in versionOptions"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cacel">取 消</el-button>
      <el-button type="primary" @click="makeSure">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'ModifySolidityContract',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  props: {
    dialogVisible: Boolean,
    contractInfo: {
      type: Object,
      default: () => {
        return {
          ID: '',
          Filename: '',
          TaskCount: 0,
          Type: '',
          SolcVersion: '',
          CreatedAt: 0,
          UpdatedAt: 0
        }
      }
    }
  },
  data() {
    return {
      model: {
        name: '',
        type: 'solidity',
        version: null
      },
      rules: {
        type: [{ required: true, message: '请选择文件类型', trigger: 'blur' }],
        version: [{ required: true, message: '请选择Solidity版本', trigger: 'blur' }]
      },
      typeOptions: [
        {
          id: 'solidity',
          name: '源码文件'
        },
        {
          id: 'bytecode',
          name: '字节码文件'
        }
      ],
      versionOptions: [],
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    contractInfo: {
      handler(val, oldval) {
        this.model.name = val.Filename
        this.model.type = val.Type
        this.model.version = val.SolcVersion
      },
      deep: true
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    }
  },
  methods: {
    handleOpen() {
      this.getSolidityVersions()
    },
    cacel() {
      this.showDialog = false
    },
    makeSure() {
      let self = this
      this.$refs['editSolidityContract'].validate(valid => {
        if (valid) {
          console.log('submit!')

          self.$apis.contractdetector
            .modifySolidityContract({
              ContractID: self.contractInfo.ID,
              SolcVersion: self.model.version,
              ContractType: self.model.type
            })
            .then(res => {
              if (res && res.data && res.code === 1) {
                self.showDialog = false

                self.$emit('editSuccess')
                self.$message({
                  type: 'success',
                  message: '更新合约成功!'
                })
              } else {
                if (!res.error) {
                  self.$message({
                    type: 'error',
                    message: '更新合约失败!'
                  })
                } else {
                  const h = self.$createElement
                  self.$message({
                    type: 'error',
                    message: h('p', null, [
                      h('div', { style: 'color: red' }, '更新合约失败!'),
                      h('div', { style: 'color: teal' }, res.error)
                    ])
                  })
                }
              }
              // console.log(res)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSolidityVersions() {
      let self = this
      this.$apis.contractdetector
        .getSolidityVersions()
        .then(data => {
          if (data && data.data && data.code == 1) {
            let versions = []
            for (let i = 0; i < data.data.length; i++) {
              versions.push({
                id: data.data[i],
                name: data.data[i]
              })
            }
            self.versionOptions = versions
          } else {
            console.log(e)
          }
        })
        .catch(e => {
          console.log(e)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.modify-solidity-contract-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .alert-info {
    margin-bottom: var(--base-size-20);
    width: 90%;
    margin-left: 5%;
  }

  .el-form {
    margin-right: var(--base-size-48);
  }
}
</style>
